import { render } from "./PaymentSlipHistoryAcceptanceDetail.vue?vue&type=template&id=4f0d7253&scoped=true"
import script from "./PaymentSlipHistoryAcceptanceDetail.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipHistoryAcceptanceDetail.vue?vue&type=script&lang=ts"

import "./PaymentSlipHistoryAcceptanceDetail.vue?vue&type=style&index=0&id=4f0d7253&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4f0d7253"

export default script